goog.provide('el8.appchart.visitNote.vitals');

goog.require('el8.appchart.visitNote.textarea');
goog.require('el8.ptdata.model.note.visit');

/**
 * This file manages a vitalsSet for a VisitNote, handling saving, population, etc.
 */
el8.appchart.visitNote.vitals = function(spec) {

    this._form = spec.form;
    this._container = spec.container;
    this._fields = spec.fields;
    this._name = spec.name;
    this._vitalClass = spec.vitalClass || this._name;
    this._selector = spec.selector || null;
    this._note = spec.note;
    this._changeFn = spec.changeFn;
    this._valueChangeFn = spec.valueChangeFn; // Ignores changes to notes field
    this._cleanInputFn = spec.cleanInputFn || function(a) { return a; };
    this._vitalsProcessor = spec.vitalsProcessor;
    this._isFirstSave = true;
    this._isDirty = false;
    this.saveCb = spec.saveCb

    this._vitalsSet = this._note.getVitalsSets()[this._vitalClass];

    this._saveFn = function(opts) {
        opts = opts || {};
        var isChanged = false;
        var that = this;
        for (var i=0; i<this._fields.length; i++) {
            var fieldName = this._fields[i].name;
            var val = this._cleanInputFn(this._form.getInfoField(fieldName).getVal(), fieldName);
            var property = this._fields[i].property || fieldName;
            var oldVal = this._vital['get'+property.toUpperCamel()]();
            if (oldVal !== val) {
                isChanged = true;
                this._vital['set'+property.toUpperCamel()](val);

                // Send up the data necessary to calculate deltas if applicable,
                // i.e., if this field has previous values associated with it.
                // BMI is handled in vitalsProcessor:saveBmi because its data model
                // is different. We ignore height here because we don't _display_
                // the previous values associated with it.
                if (this._vital.isCustom()) {
                    var previousObservations = this._vitalsProcessor.getPreviousCustomObservations();
                    if (previousObservations && previousObservations[fieldName]) {
                        var previousForVital = previousObservations[fieldName];
                        this._vital.setPreviousValue(previousForVital.previous_value);
                        this._vital.setPreviousTime(previousForVital.previous_time);
                    }
                } else if (fieldName === 'weight') {
                    this._vital.setPreviousValue(this._note.getPreviousWeight());
                }
            }
        }
        // Only save if vital has changed, or if vital has no ID
        if (isChanged || this._isDirty || !this._vital.getId()) {
            // Need blocking call if vital doesn't have an ID, OR if this is an edit
            // and it is the first save
            if (!this._vital.getId() || (this._vital.getEditId() && this._isFirstSave)) {
                opts.async = false;
            }
            this._isDirty = true;
            var that = this;
            this._vitalsSet.saveItem(this._vital, false, {
                successCb: function() {
                    that._isFirstSave = false;
                    that._isDirty = false;
                    if (that.saveCb) { that.saveCb(that) }
                    if (opts.successCb) { opts.successCb(that); }
                },
                errorCb: function() {
                    that._isDirty = true;
                    if (opts.errorCb) { opts.errorCb(); }
                },
                async: opts.async
            });
        }
    };
};



el8.appchart.visitNote.vitals.prototype.create = function() {
    for (var i=0; i<this._fields.length; i++) {
        this._form.addField(this._fields[i]);
        var fieldName = this._fields[i].name;
        var that = this;
        var $inputField = this._form.getInfoField(fieldName).getInputField();

        // change handler
        $inputField.on('change', function(e) {
            that._isDirty = true;
            that._saveFn({
                successCb: function() {
                    that._isDirty = false;
                },
                errorCb: function() {
                    that._isDirty = true;
                }
            });
            if (that._changeFn) { that._changeFn(); }
        });

        // For some reason, the value fields don't always have 'property' defined,
        // but the note fields always have it
        if (that._valueChangeFn && this._fields[i].property !== 'extraNote') {
            $inputField.on('change', function(e) {
                that._valueChangeFn();
            });
        }
    }
    return this;
};

el8.appchart.visitNote.vitals.prototype.populate = function(_vital) {
    var addedVal = false;
    this._vital = _vital || this._vitalsSet.create({});
    // If we're in edit mode...
    if (this._note.getCurrentEditId()) {
        this._vital.setEditId(this._note.getCurrentEditId());
    }
    // we'll wait to save this / actually get an ID until some data has changed

    for (var i=0; i<this._fields.length; i++) {
        var fieldName = this._fields[i].name;
        var property = this._fields[i].property || fieldName;
        var val = this._vital['get'+property.toUpperCamel()]();
        if (val) {
            el8.appchart.visitNote.vitalFields.populateField(this._fields[i], val, this._form);
            addedVal = true;
        }
    }
    return addedVal;
};

el8.appchart.visitNote.vitals.prototype.saveIfDirty = function() {
    // Use the _isDirty prop set on this by the change handler since there's no clean
    // way to serialize the data here for comparison (see _saveFn above)
    if (this._isDirty) { this._saveFn({async: false}); }
};

el8.appchart.visitNote.vitals.prototype.destroy = function() {
    if (this._vital && this._vital.getId()) {
        this._vitalsSet.deleteItem(this._vital, true, {
            successCb: function(vital) {}
        });
    }
    if (this._selector) {
        $(this._selector+':first', this._form.getContainer()).remove();
    }
};
